import { get } from 'services/client'

const fetchVendorDetails = id => get(`procurements/vendors/${id}`)

export { fetchVendorDetails }
